<template>
  <div>
    <div class="min-h-screen bg-white flex flex-col items-center pt-120px">
      <!-- 成功图标 -->
      <div class="w-64px h-64px rounded-full bg-#1ECA6D flex items-center justify-center">
        <!-- <van-icon name="success" class="text-32px text-#fff" /> -->
        <van-icon :name="successImg" size="60px" />
      </div>

      <!-- 标题 -->
      <div class="text-20px font-500 text-center mt-22px">转赠成功</div>

      <!-- 说明文字 -->
      <div class="text-14px text-999 text-center mt-12px">可以在"{{ depositName }}"中查看</div>

      <!-- 返回按钮 -->
      <div class="w-full px-24px mt-80px text-center">
        <van-button round class="h-48px w-295px" color="#FD7F5C" @click="handleBack"> 返回{{ depositName }} </van-button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { Icon as vanIcon } from 'vant'
import successImg from '@/assets/img/success@2x.png'
import usePage from '@/hooks/usePage'
import { useUserStore } from '@/store/user'

const { navigateBack } = usePage()
const userStore = useUserStore()
const depositName = computed(() => userStore.getDepositName)

// 返回预存款
const handleBack = () => {
  navigateBack({ reload: true }, null, 3)
}
</script>

<style lang="less" scoped></style>
